import types from '../types';

export const initialState = {};

export default function vendorReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_VENDOR:
      const vendor = action.payload;
      if(action.payload !== null) {
        return vendor;
      } else return state;
    default:
      return state;
  }
};
